import { LegalEntityPriceListData } from 'chaika-frontend-types/frontend-cms';

import { DateHelper } from '@utils/DateHelper';

export enum LegalEntityPriceStatus {
    Planned = 'planned',
    Active = 'Активно',
    Archived = 'archive',
}

export interface LegalEntityPriceListWithStatusData extends LegalEntityPriceListData {
    status: LegalEntityPriceStatus;
}

export function calculateLegalEntityPriceStatus({
    archivedAt,
    scheduledOn,
}: LegalEntityPriceListData): LegalEntityPriceStatus {
    const now = Date.now();
    const isPlanned = DateHelper.isAfter(scheduledOn, now);
    const isArchived = !!archivedAt && DateHelper.isAfter(now, archivedAt);

    return isPlanned
        ? LegalEntityPriceStatus.Planned
        : isArchived
          ? LegalEntityPriceStatus.Archived
          : LegalEntityPriceStatus.Active;
}
